export const SELECT_TIME_PERIOD = 'Select Time Period';
export const CUSTOM = 'custom';
export const RIGHT = 'Right';
export const MODAL_HEIGHT = '450px';
export const TODAY = 'today';
export const YESTERDAY = 'yesterday';
export const LAST_7_DAYS = 'last 7 days';
export const LAST_30_DAYS = 'last 30 days';
export const LAST_60_DAYS = 'last 60 days';
export const SINGLE = 'single';
export const RANGE = 'range';
export const DISPLAY_VALUE = {
  TODAY: 'Today',
  YESTERDAY: 'Yesterday',
  LAST_7_DAYS: 'Last 7 days',
  LAST_30_DAYS: 'Last 30 days',
  LAST_60_DAYS: 'Last 60 days',
  CUSTOM: 'Custom Date Range',
};
